export default {
  english: 'الأنجليزية',
  arabic: 'العربية',
  login: 'تسجيل الدخول',
  cart: 'سلة المشتريات',
  sidebar: {
    dashboard: 'لوحة التحكم',
    products: 'المنتجات',
    orders: 'طلبات',
    offers: 'العروض',
    withdraw: 'سحب',
    reviews: 'التعليقات',
    categories: 'الأقسام',
    discount: 'خصومات',
    collection: 'المجموعات',
    processing: 'فى الإنتظار',
    settings: 'الضبط',
    collections: 'مجموعات',
    support: 'الدعم الفني',
    logout: 'تسجيل الخروج'
  },
  table: {
    empty: 'لا توجد سجلات لإظهارها'
  }
}
